{
  "appTitle": "BACK OFFICE",
  "greetings": [
    "Salut ! Ravi de te revoir !",
    "Bon retour ! Prêt à plonger ?",
    "Content de vous retrouver !",
    "Bonjour ! Mettons-nous au travail.",
    "De retour ? C'est parti !",
    "Ravi de vous voir. Connectons-nous."
  ],
  "email": "E-mail",
  "continue": "Continuer",
  "password": "Mot de passe",
  "sign-in": "Se connecter",
  "back": "Utiliser une autre adresse e-mail",
  "sso-redirecting": "Redirection vers SSO...",
  "or": "ou",
  "passkey": {
    "signIn": "Se connecter avec une passkey",
    "error": "Échec de la connexion par passkey. Réessayez ou utilisez votre mot de passe.",
    "unknownCredential": "Cette passkey n'est pas reconnue. Veuillez vous connecter avec votre mot de passe."
  },
  "mfa": {
    "label": "Code d'authentification",
    "hint": "Entrez le code à 6 chiffres de votre application d'authentification.",
    "verify": "Vérifier",
    "invalidCode": "Code incorrect — veuillez réessayer."
  },
  "changePassword": {
    "description": "Votre mot de passe doit être mis à jour avant de continuer.",
    "current": "Mot de passe actuel",
    "new": "Nouveau mot de passe",
    "confirm": "Confirmer le nouveau mot de passe",
    "submit": "Mettre à jour le mot de passe",
    "mismatch": "Les nouveaux mots de passe ne correspondent pas.",
    "wrongCurrent": "Le mot de passe actuel est incorrect.",
    "error": "Impossible de mettre à jour le mot de passe. Veuillez réessayer."
  },
  "errors": {
    "invalidCredentials": "Connexion impossible, vérifiez vos identifiants et réessayez",
    "unauthorized": "Connexion impossible, veuillez réessayer",
    "accountLocked": "Le compte est verrouillé, réessayez plus tard",
    "accessNotGranted": "Accès au Back Office non autorisé",
    "ssoRequired": "Ce compte utilise l'authentification unique (SSO). Veuillez vous connecter via SSO."
  }
}
